import React from 'react';
import styled from 'styled-components';

interface LoadingBarProps {}

const ComponentWrapper = styled.div`
  width: 100%;
  height: 100px;

  .wrapper {
    width: 100%;
    height: 100%;
  }
  .wrapper {
    position: relative;
  }
  .progressbar {
    display: block;
    position: absolute;
    z-index: 9;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 400px;
    height: 30px;
  }
  .progressbar::before,
  .progressbar::after {
    content: '';
    display: block;
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    background-image: -webkit-gradient(linear, left top, right top, from(#d1296d), color-stop(20%, #d1296d), color-stop(20%, #32afe0), color-stop(40%, #32afe0), color-stop(40%, #45c94e), color-stop(60%, #45c94e), color-stop(60%, #fed700), color-stop(80%, #fed700), color-stop(80%, #f99848), to(#f99848));
    background-image: linear-gradient(90deg, #d1296d 0%, #d1296d 20%, #32afe0 20%, #32afe0 40%, #45c94e 40%, #45c94e 60%, #fed700 60%, #fed700 80%, #f99848 80%, #f99848 100%);
    background-position: 0 0;
    background-repeat: repeat-x;
    -webkit-animation: movebar 5s linear infinite;
            animation: movebar 5s linear infinite;
  }
  .progressbar::before {
    box-shadow: 0 6px 10px 0 rgba(0,0,0,0.1);
  }
  .progressbar::after {
    z-index: 9;
    top: 6px;
    -webkit-filter: blur(16px);
            filter: blur(16px);
    opacity: 0.7;
  }
  .stylization {
    position: absolute;
    z-index: 999;
    height: 4px;
    width: 90%;
    left: 5%;
    top: 6px;
    opacity: 0.3;
  }
  .stylization::before,
  .stylization::after {
    content: '';
    display: block;
    position: absolute;
    height: 4px;
    top: 0;
    border-radius: 2px;
  }
  .stylization::before {
    background: #fff;
    left: 0;
    right: 10px;
  }
  .stylization::after {
    width: 6px;
    background: #fff;
    right: 0;
  }
  @-webkit-keyframes movebar {
    from {
      background-position: 0 0;
    }
    to {
      background-position: 400px 0;
    }
  }
  @keyframes movebar {
    from {
      background-position: 0 0;
    }
    to {
      background-position: 400px 0;
    }
  }
`;

const LoadingBar: React.FC<LoadingBarProps> = () => (
  <ComponentWrapper>
    <div className="wrapper">
      <div className="progressbar">
        <div className="stylization" />
      </div>
    </div>
  </ComponentWrapper>
);

export default LoadingBar;
